<script>
import { mapActions } from 'vuex'
import AppNotificacao from '@/components/mixins/AppNotificacao'

export default {
  name: 'Login',

  mixins: [
    AppNotificacao
  ],

  data () {
    return {
      codigo: '',
      senha: '',
      confirmarSenha: '',
      loading: false
    }
  },

  created () {
    this.codigo = this.$route.params.codigo
  },

  methods: {
    ...mapActions({
      redefinirSenha: 'usuario/redefinirSenha'
    }),
    async cadastrarNovaSenha () {
      if (await this.$refs.observer.validate()) {
        await this.redefinirSenha({
          senha: this.senha,
          codigoAcesso: this.codigo
        })
        this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS, 'Senha alterada com sucesso.')
        this.$router.push({ name: 'login' })
      } else {
        this.showNotificacao(
          this.$messages.TIPO_WARNING,
          this.$messages.TITULO_WARNING,
          this.$messages.ERRO_VALIDACAO_CAMPOS_OBRIGATORIOS
        )
      }
    }
  }
}
</script>

<template>
  <div>
    <div class="main">
      <el-card class="box-card">
        <validation-observer ref="observer" tag="form">
          <form @keyup.enter="cadastrarNovaSenha()">
            <div id="containerImagens">
              <div>
                <img class="logo" src="@/assets/images/logo.png" />
              </div>
              <div id="LineSeparator"></div>
              <div>
                <img class="logo" src="@/assets/images/logoAbcPa.png" />
              </div>
            </div>

            <div class="item">
              <validation-provider rules="required|min:6" v-slot="{ errors }" name="senha" mode="lazy">
                <el-input
                  class="input"
                  :class="{ erro: errors.length }"
                  placeholder="Senha"
                  id="input_senha"
                  type="password"
                  v-model="senha"
                />
                <span class="help erro">{{ errors[0] }}</span>
              </validation-provider>
            </div>

            <div class="item">
              <validation-provider rules="required|password_confirmation:@senha" v-slot="{ errors }" name="confirmarSenha">
                <el-input
                  class="input"
                  :class="{ erro: errors.length }"
                  placeholder="Confirmar senha"
                  v-model="confirmarSenha"
                  id="input_confirmar_senha"
                  type="password"
                />
                <span class="help erro">{{ errors[0] }}</span>
              </validation-provider>
            </div>

            <div class="item">
              <el-button
                class="full-width"
                @click="cadastrarNovaSenha()"
                :disabled="loading"
                type="success"
                style="width: 100%;"
              >
                <span v-if="!loading">Confirmar</span>
                <i v-else class="el-icon-loading"></i>
              </el-button>
            </div>
          </form>
        </validation-observer>
      </el-card>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/styles/_variables.scss";
@import './styles.scss';
</style>



// WEBPACK FOOTER //
// src/App/(unauthenticated)/seguranca/cadastro-senha/cadastro-senha.vue